import axios from "axios";
import { getToken } from "./token";

// const URL = window.location.hostname == '192.168.10.136' ? 'http://192.168.10.136/api/' : 'https://apistartin.d3t.com.br/api/';
const URL = window.location.hostname == 'localhost' ? 'http://localhost/api/' : 'https://apistartin.d3t.com.br/api/';
const URL_FILE = window.location.hostname == 'localhost' ? 'http://localhost/documentos/' : 'https://apistartin.d3t.com.br/documentos/';

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('error')
  console.log(error)
  return Promise.reject(error)
});

class Api {
  static get(path) {
    return axios.get(`${URL}${path}`, this._getRequestOptions());
  }

  static post(path, body) {
    return axios.post(`${URL}${path}`, body, {
      headers: this._getHeaders()
    });
  }

  static put(path, body) {
    return axios.put(`${URL}${path}`, body, this._getRequestOptions());
  }

  static delete(path) {
    return axios.delete(`${URL}${path}`, this._getRequestOptions());
  }

  static _getRequestOptions(options = {}) {
    let requestOption = {};
    requestOption.headers = this._getHeaders(options.headers);
    return requestOption;
  }
  static _getHeaders() {
    let headers = {
      "Content-Type": "application/json"
    };
    if (localStorage.getItem('token')) {
      headers.Authorization = 'Bearer ' + getToken();
    }
    return headers;
  }
  static headers() {
    return this._getHeaders();
  }
  static getApUrl() {
    return URL;
  }
  static getTokenAut() {
    return 'Bearer ' + getToken();
  }
}

export default Api;
export const API_URL = URL;
export const API_URL_FILE = URL_FILE;



//////////////////
// WEBPACK FOOTER
// ./config/api.helper.js
// module id = null
// module chunks = 